var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51798 1.12988C7.65292 0.640387 8.34708 0.640388 8.48202 1.12988L9.40431 4.47545C9.59038 5.15042 10.2187 5.60688 10.9181 5.57527L14.3849 5.41859C14.8922 5.39566 15.1067 6.05585 14.6828 6.33544L11.786 8.24643C11.2016 8.63198 10.9616 9.37055 11.2078 10.026L12.4281 13.2747C12.6067 13.75 12.0451 14.1581 11.6482 13.8414L8.93557 11.6769C8.38829 11.2402 7.61171 11.2402 7.06443 11.6769L4.35181 13.8414C3.95492 14.1581 3.39334 13.75 3.57188 13.2747L4.79221 10.026C5.03841 9.37056 4.79843 8.63198 4.21399 8.24643L1.31717 6.33544C0.893339 6.05585 1.10785 5.39566 1.61508 5.41859L5.08191 5.57527C5.78134 5.60688 6.40962 5.15042 6.59569 4.47545L7.51798 1.12988Z",
    fill: "#FFCC00",
    stroke: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e312373d028d11017f98a8f20fa8ae0c.svg";
export { ForwardRef as ReactComponent };